import React from 'react'

import axios from 'axios'

import type {
  GeocodeContextData,
  GeocodeSearchOptions,
  GeocodeSearchReturn,
  ProviderProps,
} from '../helpers/types/context/geocode.types'

import { formatError } from '../helpers/errors'

export const GeocodeContext = React.createContext<GeocodeContextData>(
  {} as GeocodeContextData
)

export function GeocodeProvider({ children }: ProviderProps) {
  async function search(
    value: string,
    options: GeocodeSearchOptions
  ): Promise<GeocodeSearchReturn> {
    try {
      const params = new URLSearchParams()

      params.append('key', process.env.REACT_APP_PARKOFF_GOOGLE_MAPS_API_KEY as string)
      params.append(options.types, value)
      options.language && params.append('language', options.language)

      const result = await axios.get<GeocodeSearchReturn>(
        `${process.env.REACT_APP_PARKOFF_GOOGLE_MAPS_API_URL}/json`,
        { params }
      )

      return result.data
    } catch (err) {
      throw formatError(err as Error)
    }
  }

  return (
    <GeocodeContext.Provider value={{ search }}>
      {children}
    </GeocodeContext.Provider>
  )
}
